function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M76.252 53.783L62.702 67.18l32.715 32.346L147.3 48.231l-13.55-13.397-38.332 37.898z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M190.91 47.773v85.885H19.09V47.773H0v133.599C0 197.182 12.82 210 28.636 210h152.728C197.179 210 210 197.183 210 181.372v-133.6h-19.09z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48.021 19.14h114.953v105.268h19.159V9.57c0-5.285-4.29-9.57-9.58-9.57H38.442c-5.29 0-9.58 4.285-9.58 9.57v114.838h19.16V19.14z"
});

const SvgArchive = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArchive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/archive.4e8a2818.svg";
export { ForwardRef as ReactComponent };